import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import { Multiselect } from "multiselect-react-dropdown"
import AgentExtraEmployee from "./AgentExtraEmployee"

import ReactExport from "react-data-export"
import AddIcon from "@material-ui/icons/Add"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
            marginTop: "15px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
            padding: " 10px",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})

class ChangeAgent extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.multiselectCompanyRef = React.createRef()
            this.multiselectStateRef = React.createRef()
            this.multiselectCityRef = React.createRef()

            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  agentExtraEmployee: [],
                  rowsPerPage: 5,
                  page: 0,
                  agent_id: "",
                  agent_code: "",
                  agent_name: "",
                  agent_family: "",
                  agent_mobile: "",
                  agent_tell: "",
                  agent_required_phone: "",
                  agent_email: "",
                  agent_address: "",
                  agent_bankname: "",
                  agent_banknum: "",
                  agent_banksheba: "",
                  agent_sector_name: "",
                  agent_percent_issuing_salary: "",
                  agent_company_name: "",
                  agent_city_name: "",
                  agent_deactive: "1",
                  agent_status: "1",
                  agent_image: "",
                  agent_company_logo_url: "",
                  orderBy: "agent_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newAgent: true,
                  picturesRequestReady: "",
                  selectedAgentExtraEmployee: "",

                  optionGender: [
                        { value: "آقا", label: "آقا" },
                        { value: "خانم", label: "خانم" },
                        { value: "حقوقی", label: "حقوقی" },
                  ],
                  selectedGender: "",

                  optionComoany: [],
                  optionFilterComoany: "",
                  selectedComoany: "",

                  optionState: [],
                  selectedState: "",
                  optionCity: [],
                  optionFilterCity: [],
                  selectedCity: "",

                  loading: false,
                  percent: 0,
                  selectedFilterCompany: [],
                  selectedFilterState: [],
                  selectedFilterCity: [],
                  selectedFilterDeactive: "",
                  selectedFilterStatus: "",
                  idFilter: "",
                  codeFilter: "",
                  nameFilter: "",
                  familyFilter: "",
                  mobileFilter: "",
                  showPaperChart: false,
                  showMap: false,
                  showEnterAgent: false,
            }
      }

      handleBodycarExtracar = (selectedAgentExtraEmployee) => {
            this.setState({ selectedAgentExtraEmployee: selectedAgentExtraEmployee })
      }
      handleShowPaperChart = (event) => {
            this.setState({ showPaperChart: true })
      }

      handleHidePaperChart = (event) => {
            this.setState({ showPaperChart: false })
      }

      handleShowMap = (event) => {
            this.setState({ showMap: true })
      }

      handleHideMap = (event) => {
            this.setState({ showMap: false })
      }

      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handleChangeName = (event) => {
            this.setState({ agent_name: event.target.value })
      }
      handleChangCode = (event) => {
            this.setState({ agent_code: event.target.value })
      }
      handleChangeFamily = (event) => {
            this.setState({ agent_family: event.target.value })
      }

      handleChangeMobile = (event) => {
            this.setState({ agent_mobile: event.target.value })
      }

      handleChangeTell = (event) => {
            this.setState({ agent_tell: event.target.value })
      }
      handleChangeTellRequir = (event) => {
            this.setState({ agent_required_phone: event.target.value })
      }
      handleChangeEmail = (event) => {
            this.setState({ agent_email: event.target.value })
      }
      handleChangeAddress = (event) => {
            this.setState({ agent_address: event.target.value })
      }
      handleChangeBankName = (event) => {
            this.setState({ agent_bankname: event.target.value })
      }
      handleChangeBankNum = (event) => {
            this.setState({ agent_banknum: event.target.value })
      }
      handleChangeBankSheba = (event) => {
            this.setState({ agent_banksheba: event.target.value })
      }
      handleChangeSector = (event) => {
            this.setState({ agent_sector_name: event.target.value })
      }
      handleChangePercentIssuingSalary = (event) => {
            this.setState({ agent_percent_issuing_salary: event })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ agent_deactive: "0" })
            } else {
                  this.setState({ agent_deactive: "1" })
            }
      }

      handleChangeStatus = (event) => {
            if (event.target.checked) {
                  this.setState({ agent_status: "1" })
            } else {
                  this.setState({ agent_status: "0" })
            }
      }

      handleSelectRows = (row2) => {
            console.log('row2', row2);

            this.getAgentExtraEmployee(row2.agent_id);

            let selectedCompany;
            if (row2.agent_company_id === "0") {

                  console.log('heh');

                  selectedCompany = { value: "0", label: "همه شرکت‌ها", logo: null };
            } else {
                  selectedCompany = {
                        value: row2.agent_company_id,
                        label: row2.agent_company_name,
                        logo: row2.agent_company_logo_url
                  };
            }

            this.setState(
                {
                      agent_code: row2.agent_code,
                      agent_id: row2.agent_id,
                      agent_name: row2.agent_name,
                      agent_family: row2.agent_family,
                      agent_mobile: row2.agent_mobile,
                      agent_tell: row2.agent_tell,
                      agent_required_phone: row2.agent_required_phone,
                      agent_email: row2.agent_email,
                      agent_address: row2.agent_address,
                      agent_bankname: row2.agent_bankname,
                      agent_banknum: row2.agent_banknum,
                      agent_banksheba: row2.agent_banksheba,
                      agent_sector_name: row2.agent_sector_name,
                      agent_percent_issuing_salary: row2.agent_percent_issuing_salary,
                      agent_deactive: row2.agent_deactive,
                      agent_status: row2.agent_status,
                      agent_image: row2.agent_image,
                      agent_company_logo_url: row2.agent_company_logo_url,
                      newAgent: false,
                      selectedGender: { value: row2.agent_gender, label: row2.agent_gender },
                      selectedComoany: selectedCompany,  // 👈 اینجا درست شد
                      selectedState: { value: row2.agent_state_id, label: row2.agent_state_name },
                      selectedCity: { value: row2.agent_city_id, label: row2.agent_city_name },
                      showEnterAgent: true,
                },
                () => {
                      this.getoptionCityID();
                }
            );
      };


      getAgentExtraEmployee(agent_id) {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ agentExtraEmployee: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ agentExtraEmployee: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_agent_extraemployee")
                  fd.append("agent_id", agent_id)

                  xhttp.open("POST", `${constants.BASE_URL}/agent`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      newAgentFunc = (event) => {
            this.setState({
                  agent_id: "",
                  agent_code: "",
                  agent_name: "",
                  agent_family: "",
                  agent_mobile: "",
                  agent_tell: "",
                  agent_required_phone: "",
                  agent_email: "",
                  agent_address: "",
                  agent_bankname: "",
                  agent_banknum: "",
                  agent_banksheba: "",
                  agent_sector_name: "",
                  agent_percent_issuing_salary: "0",
                  agent_deactive: "0",
                  agent_status: "0",
                  agent_image: "",
                  agent_company_logo_url: "",
                  newAgent: true,
                  selectedGender: {},
                  selectedComoany: {},
                  selectedState: {},
                  selectedCity: {},
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getAgent()
                                    self.getoptionStateID()
                                    self.getoptionCompany()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getAgent() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState(
                                    {
                                          requestinfos: arr.data,
                                          agentInfofilter: arr.data,
                                    },
                                    () => {}
                              )
                              self.getoptionBodycarExtracar()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        } else if (arr.result === "eror") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_agent")

            xhttp.open("POST", `${constants.BASE_URL}/agent`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionBodycarExtracar = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].employee_id,
                                          label: arr.data[k].employee_name + " " + arr.data[k].employee_family,
                                    })
                              }
                              self.setState({ optionBodycarExtracar: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee")
            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Comoany = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Comoany.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              Comoany.unshift({
                                    value: "0",
                                    label: "همه شرکت‌ها",
                                    logo: null
                              })
                              self.setState({ optionComoany: Comoany, selectedComoany: Comoany[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getoptionStateID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].state_id, label: arr.data[k].state_name })
                              }
                              self.setState({ optionState: State }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_state")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getoptionCityID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", this.state.selectedState.value)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      uploadPicDelivery = (mode) => {
            const {
                  agent_name,
                  agent_family,
                  agent_code,
                  agent_mobile,
                  agent_tell,
                  agent_required_phone,
                  agent_address,
                  agent_bankname,
                  agent_banknum,
                  agent_banksheba,
                  agent_sector_name,
                  agent_percent_issuing_salary,
                  selectedComoany,
                  selectedGender,
                  selectedState,
                  selectedCity,
                  agent_deactive,
                  agent_status,
            } = this.state
            const { picturesRequestReady } = this.state
            if (
                  agent_code != "" &&
                  agent_name != "" &&
                  agent_family != "" &&
                  agent_mobile != "" &&
                  agent_tell != "" &&
                  agent_address != "" &&
                  agent_bankname != "" &&
                  agent_banknum != "" &&
                  agent_banksheba != "" &&
                  selectedComoany != "" &&
                  selectedGender != "" &&
                  selectedState != "" &&
                  selectedCity != "" &&
                  agent_deactive != "" &&
                  agent_status != ""
            ) {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewAgent(arr.data["image_code"])
                                          } else {
                                                self.changeAgent(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر نماینده")
                        fd.append("image_desc", "تصویر نماینده")
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        if (mode === "new") {
                              this.saveNewAgent("")
                        } else {
                              this.changeAgent("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات نماینده را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      deleteAgent = () => {
            const {
                  agent_id,
            } = this.state
            console.log("sfdjsdklf");

            if (
                agent_id != ""
            ) {


                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          self.getAgent()

                                    } else if (arr.result === "error") {
                                          console.log("servererro")
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "delete_agent")
                        fd.append("agent_id", agent_id)
                  xhttp.open("POST", `${constants.BASE_URL}/agent`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)

            } else {
                  this.setState({ snackstr: "لطفا مشخصات نماینده را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewAgent = (imageCode) => {
            const {
                  agent_name,
                  agent_family,
                  agent_code,
                  agent_mobile,
                  agent_tell,
                  agent_required_phone,
                  agent_email,
                  agent_address,
                  agent_bankname,
                  agent_banknum,
                  agent_banksheba,
                  agent_sector_name,
                  agent_percent_issuing_salary,
                  selectedComoany,
                  selectedGender,
                  selectedState,
                  selectedCity,
                  agent_deactive,
                  agent_status,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getAgent()
                              self.newAgentFunc()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_agent")
            fd.append("agent_name", agent_name)
            fd.append("agent_code", agent_code)
            fd.append("agent_family", agent_family)
            fd.append("agent_mobile", agent_mobile)
            fd.append("agent_tell", agent_tell)
            fd.append("agent_required_phone", agent_required_phone)
            fd.append("agent_email", agent_email)
            fd.append("agent_address", agent_address)
            fd.append("agent_bankname", agent_bankname)
            fd.append("agent_banknum", agent_banknum)
            fd.append("agent_banksheba", agent_banksheba)
            fd.append("agent_sector_name", agent_sector_name)
            fd.append("agent_percent_issuing_salary", agent_percent_issuing_salary)
            fd.append("agent_company_id", selectedComoany.value)
            fd.append("agent_gender", selectedGender.value)
            fd.append("agent_state_id", selectedState.value)
            fd.append("agent_city_id", selectedCity.value)
            fd.append("agent_deactive", agent_deactive)
            fd.append("agent_image_code", imageCode)
            fd.append("agent_status", agent_status)

            xhttp.open("POST", `${constants.BASE_URL}/agent`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeAgent = (imageCode) => {
            const {
                  agent_id,
                  agent_code,
                  agent_name,
                  agent_family,
                  agent_mobile,
                  agent_tell,
                  agent_required_phone,
                  agent_email,
                  agent_address,
                  agent_bankname,
                  agent_banknum,
                  agent_banksheba,
                  agent_sector_name,
                  agent_percent_issuing_salary,
                  selectedComoany,
                  selectedGender,
                  selectedState,
                  selectedCity,
                  agent_deactive,
                  agent_status,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getAgent()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_agent")
            fd.append("agent_id", agent_id)
            fd.append("agent_name", agent_name)
            fd.append("agent_code", agent_code)
            fd.append("agent_family", agent_family)
            fd.append("agent_mobile", agent_mobile)
            fd.append("agent_tell", agent_tell)
            fd.append("agent_required_phone", agent_required_phone)
            fd.append("agent_email", agent_email)
            fd.append("agent_address", agent_address)
            fd.append("agent_bankname", agent_bankname)
            fd.append("agent_banknum", agent_banknum)
            fd.append("agent_banksheba", agent_banksheba)
            fd.append("agent_sector_name", agent_sector_name)
            fd.append("agent_percent_issuing_salary", agent_percent_issuing_salary)
            fd.append("agent_company_id", selectedComoany.value)
            fd.append("agent_gender", selectedGender.value)
            fd.append("agent_state_id", selectedState.value)
            fd.append("agent_city_id", selectedCity.value)
            fd.append("agent_deactive", agent_deactive)
            if (imageCode !== "") {
                  fd.append("agent_image_code", imageCode)
            }
            fd.append("agent_status", agent_status)

            xhttp.open("POST", `${constants.BASE_URL}/agent`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      handleState = (selectedState) => {
            this.setState({ selectedState: selectedState, selectedCity: null }, () => {
                  this.getoptionCityID()
            })
      }

      handleCity = (selectedCity) => {
            this.setState({ selectedCity: selectedCity })
      }

      handleCompany = (selectedComoany) => {
            this.setState({ selectedComoany: selectedComoany })
      }
      handleGender = (selectedGender) => {
            this.setState({ selectedGender: selectedGender })

            if(selectedGender.value === "حقوقی") {
                  this.setState({agent_name: "شرکت"})
                  console.log("agent_name", this.agent_name);

            }

      }

      onSelectOptionCompany = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCompany = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }
      onSelectOptionCity = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCity = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }
      onSelectOptionState = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }

      onRemoveOptionState = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }
      getOptionFilterCity = () => {
            const { selectedFilterState, optionState } = this.state
            this.setState({ optionFilterCity: [] }, () => {
                  for (var i = 0; i < selectedFilterState.length; i++) {
                        this.getCity(selectedFilterState[i].value)
                  }
            })
      }

      getCity = (state_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State
                              if (self.state.optionFilterCity.length > 0) {
                                    var State = self.state.optionFilterCity
                              } else {
                                    var State = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionFilterCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", state_id)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      handleFilterDeactive = (selectedFilterDeactive) => {
            this.setState({ selectedFilterDeactive: selectedFilterDeactive }, () => {})
      }
      handleFilterStatus = (selectedFilterStatus) => {
            this.setState({ selectedFilterStatus: selectedFilterStatus }, () => {})
      }
      handleChangeFilterId = (event) => {
            this.setState({ idFilter: event.target.value }, () => {})
      }

      handleChangeFilterCode = (event) => {
            this.setState({ codeFilter: event.target.value }, () => {})
      }

      handleChangeFilterName = (event) => {
            this.setState({ nameFilter: event.target.value }, () => {})
      }
      handleChangeFilterFamily = (event) => {
            this.setState({ familyFilter: event.target.value }, () => {})
      }
      handleChangeFilterMobile = (event) => {
            this.setState({ mobileFilter: event.target.value }, () => {})
      }
      filterFunc = () => {
            const {
                  requestinfos,
                  agentInfofilter,
                  selectedFilterState,
                  selectedFilterCity,
                  selectedFilterCompany,
                  idFilter,
                  codeFilter,
                  nameFilter,
                  familyFilter,
                  mobileFilter,
                  selectedFilterDeactive,
                  selectedFilterStatus,
            } = this.state
            var i, j, temparray2, temparray, b1, b2, b3
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < requestinfos.length; i++) {
                  if (temparray[i].agent_status !== "1") {
                        temparray[i].agent_status = "0"
                  }
                  if (
                        ((idFilter !== "" && temparray[i].agent_id.includes(idFilter)) || idFilter === "") &&
                        ((codeFilter !== "" && temparray[i].agent_code.includes(codeFilter)) || codeFilter === "") &&
                        ((nameFilter !== "" && temparray[i].agent_name.includes(nameFilter)) || nameFilter === "") &&
                        ((familyFilter !== "" && temparray[i].agent_family.includes(familyFilter)) || familyFilter === "") &&
                        ((mobileFilter !== "" && temparray[i].agent_mobile.includes(mobileFilter)) || mobileFilter === "") &&
                        ((selectedFilterDeactive !== "" && temparray[i].agent_deactive === selectedFilterDeactive.value) ||
                              selectedFilterDeactive === "" ||
                              selectedFilterDeactive.value === "10") &&
                        ((selectedFilterStatus !== "" && temparray[i].agent_status === selectedFilterStatus.value) ||
                              selectedFilterStatus === "" ||
                              selectedFilterStatus.value === "10")
                  ) {
                        b1 = false
                        b2 = false
                        b3 = false

                        if (selectedFilterState.length === 0) {
                              b1 = true
                        } else {
                              for (j = 0; j < selectedFilterState.length; j++) {
                                    if (temparray[i].agent_state_id === selectedFilterState[j].value) {
                                          b1 = true
                                    }
                              }
                        }
                        if (selectedFilterCity.length === 0) {
                              b2 = true
                        } else {
                              for (j = 0; j < selectedFilterCity.length; j++) {
                                    if (temparray[i].agent_city_id === selectedFilterCity[j].value) {
                                          b2 = true
                                    }
                              }
                        }
                        if (selectedFilterCompany.length === 0) {
                              b3 = true
                        } else {
                              for (j = 0; j < selectedFilterCompany.length; j++) {
                                    if (temparray[i].agent_company_id === selectedFilterCompany[j].value) {
                                          b3 = true
                                    }
                              }
                        }
                        if (b1 && b2 && b3) {
                              temparray2.push(temparray[i])
                        }
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      saveNewPriceAgentExtraEmployee = () => {
            const { agent_id, selectedAgentExtraEmployee } = this.state
            if (selectedAgentExtraEmployee != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ selectedAgentExtraEmployee: "" })
                                    self.getAgentExtraEmployee(agent_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_agent_extraemployee")
                  fd.append("agent_extra_agent_id", agent_id)
                  fd.append("agent_extra_employee_id", selectedAgentExtraEmployee.value)

                  xhttp.open("POST", `${constants.BASE_URL}/agent`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      ClearFilter = () => {
            this.setState({
                  selectedFilterCompany: [],
                  selectedFilterState: [],
                  selectedFilterCity: [],
                  selectedFilterDeactive: "",
                  selectedFilterStatus: "",
                  idFilter: "",
                  codeFilter: "",
                  nameFilter: "",
                  familyFilter: "",
                  mobileFilter: "",
                  optionFilterCity: [],
                  selectedOptionCity: [],
                  selectedOptionState: [],
                  agentInfofilter: this.state.requestinfos,
            })
            this.multiselectCompanyRef.current.resetSelectedValues()
            this.multiselectStateRef.current.resetSelectedValues()
            this.multiselectCityRef.current.resetSelectedValues()
      }
      HandelShowEnterAgent = () => {
            this.setState({
                  showEnterAgent: true,
            })
            this.newAgentFunc()
      }
      handleHideEnterAgent = () => {
            this.setState({
                  showEnterAgent: false,
            })
      }
      render() {
            const { classes } = this.props
            const {
                  selectedAgentExtraEmployee,
                  optionBodycarExtracar,
                  agentExtraEmployee,
                  showEnterAgent,
                  showPaperChart,
                  showMap,
                  mobileFilter,
                  familyFilter,
                  nameFilter,
                  codeFilter,
                  idFilter,
                  selectedFilterDeactive,
                  selectedFilterStatus,
                  loading,
                  percent,
                  optionCity,
                  optionFilterCity,
                  selectedCity,
                  selectedGender,
                  optionGender,
                  optionComoany,
                  selectedComoany,
                  optionState,
                  selectedState,
                  snackMode,
                  snackstr,
                  showSnack,
                  newAgent,
                  agent_id,
                  agent_code,
                  agent_name,
                  agent_family,
                  agent_image,
                  agent_company_logo_url,
                  agent_mobile,
                  agent_tell,
                  agent_required_phone,
                  agent_email,
                  agent_address,
                  agent_bankname,
                  agent_banknum,
                  agent_banksheba,
                  agent_sector_name,
                  agent_percent_issuing_salary,
                  agent_deactive,
                  agent_status,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      {showEnterAgent ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHideEnterAgent}>
                                                                  {"مخفی کردن"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.HandelShowEnterAgent}>
                                                                  {"نماینده جدید"}
                                                            </Button>
                                                      )}
                                                      <Collapse in={showEnterAgent}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"آی دی نماینده : " + agent_id}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <Avatar alt="Remy Sharp" className={classes.large} src={agent_image} />
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={6}>
                                                                        <Grid container spacing={3}>
                                                                              <Grid item xs={3}>
                                                                                    <div>
                                                                                          <label className="on">جنسیت </label>
                                                                                          <Select
                                                                                                isSearchable={true}
                                                                                                className="adapter-txtsize"
                                                                                                placeholder={"جنسیت "}
                                                                                                value={selectedGender}
                                                                                                onChange={this.handleGender}
                                                                                                options={optionGender}
                                                                                          />
                                                                                    </div>
                                                                              </Grid>
                                                                              <Grid item xs={9}>
                                                                                    <FloatingLabelInput
                                                                                          placeholder="نام"
                                                                                          handleInputt={this.handleChangeName}
                                                                                          value={agent_name}
                                                                                    />
                                                                              </Grid>
                                                                        </Grid>
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام خانوادگی"
                                                                              handleInputt={this.handleChangeFamily}
                                                                              value={agent_family}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره همراه "
                                                                              handleInputt={this.handleChangeMobile}
                                                                              value={agent_mobile}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره دفتر "
                                                                              handleInputt={this.handleChangeTell}
                                                                              value={agent_tell}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="ایمیل"
                                                                              handleInputt={this.handleChangeEmail}
                                                                              value={agent_email}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder=" تلفن ضروری "
                                                                              handleInputt={this.handleChangeTellRequir}
                                                                              value={agent_required_phone}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={5}>
                                                                        <div>
                                                                              <label className="on">شرکت بیمه</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"شرکت بیمه"}
                                                                                    value={selectedComoany}
                                                                                    onChange={this.handleCompany}
                                                                                    options={optionComoany}
                                                                              />
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <img
                                                                                    alt="Remy Sharp"
                                                                                    style={{ width: "25%" }}
                                                                                    src={selectedComoany.logo}
                                                                              />
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="کد نمایندگی"
                                                                              handleInputt={this.handleChangCode}
                                                                              value={agent_code}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div>
                                                                              <label className="on">استان</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"استان"}
                                                                                    value={selectedState}
                                                                                    onChange={this.handleState}
                                                                                    options={optionState}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div>
                                                                              <label className="on">شهر</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"شهر"}
                                                                                    value={selectedCity}
                                                                                    onChange={this.handleCity}
                                                                                    options={optionCity}
                                                                              />
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <FloatingLabelInput
                                                                              placeholder="آدرس"
                                                                              handleInputt={this.handleChangeAddress}
                                                                              value={agent_address}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام بانک"
                                                                              handleInputt={this.handleChangeBankName}
                                                                              value={agent_bankname}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره حساب"
                                                                              handleInputt={this.handleChangeBankNum}
                                                                              value={agent_banknum}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شبا"
                                                                              handleInputt={this.handleChangeBankSheba}
                                                                              value={agent_banksheba}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput

                                                                              placeholder="نام محله"
                                                                              handleInputt={this.handleChangeSector}
                                                                              value={agent_sector_name}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                            type="percent"
                                                                            placeholder="درصد حق صدور"
                                                                            handleInputt={this.handleChangePercentIssuingSalary}
                                                                            value={agent_percent_issuing_salary}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <ImageUploader
                                                                              withIcon={true}
                                                                              buttonText="عکس را انتخاب نمایید"
                                                                              onChange={this.onSelectPicRequest}
                                                                              withPreview="true"
                                                                              singleImage="true"
                                                                              imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                              maxFileSize={5242880}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <FormControlLabel
                                                                                    control={
                                                                                          <Switch
                                                                                                checked={agent_deactive === "0" ? true : false}
                                                                                                onChange={this.handleChangeDeactive}
                                                                                                name="gilad"
                                                                                          />
                                                                                    }
                                                                                    label="وضعیت فعالیت نماینده"
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <FormControlLabel
                                                                                    control={
                                                                                          <Switch
                                                                                                checked={agent_status === "1" ? true : false}
                                                                                                onChange={this.handleChangeStatus}
                                                                                                name="gilad"
                                                                                          />
                                                                                    }
                                                                                    label="وضعیت آنلاین"
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        {loading && <LinearProgress variant="determinate" value={percent} />}
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        {newAgent ? (
                                                                            <>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("new")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت نماینده جدید "}
                                                                              </Button>

                                                                            </>
                                                                        ) : (
                                                                              <div style={{ width: "100%", textAlign: "right" }}>
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={this.newAgentFunc}
                                                                                    >
                                                                                          {"نماینده جدید"}
                                                                                    </Button>
                                                                                    {"          "}
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={(e) => {
                                                                                                this.uploadPicDelivery("modify")
                                                                                          }}
                                                                                    >
                                                                                          {"ثبت تغییرات"}
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="outlined"
                                                                                        color="primary"
                                                                                        onClick={(e) => {
                                                                                              this.deleteAgent()
                                                                                        }}
                                                                                    >
                                                                                          {"حذف "}
                                                                                    </Button>
                                                                              </div>
                                                                        )}
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Paper
                                                                              style={{
                                                                                    backgroundColor: "#cfe8fc",
                                                                                    maxHeight: "300px",
                                                                                    overflowY: "scroll",
                                                                                    overflowX: "hidden",
                                                                              }}
                                                                              className={classes.root}
                                                                        >
                                                                              {newAgent ? null : (
                                                                                    <Grid container spacing={3}>
                                                                                          {agentExtraEmployee.map((agentExtraEmployee, index) => (
                                                                                                <AgentExtraEmployee
                                                                                                      agentExtraEmployee={agentExtraEmployee}
                                                                                                      props={this.props}
                                                                                                      key={index}
                                                                                                />
                                                                                          ))}
                                                                                    </Grid>
                                                                              )}
                                                                        </Paper>
                                                                        {newAgent ? null : (
                                                                              <Grid item xs={12}>
                                                                                    <Grid container spacing={3}>
                                                                                          <Grid item xs={5}>
                                                                                                <div>
                                                                                                      <label className="on"> خودرو های اضافه </label>
                                                                                                      <Select
                                                                                                            isSearchable={true}
                                                                                                            className="adapter-txtsize"
                                                                                                            placeholder={"  کارمندان "}
                                                                                                            value={selectedAgentExtraEmployee}
                                                                                                            onChange={this.handleBodycarExtracar}
                                                                                                            options={optionBodycarExtracar}
                                                                                                      />
                                                                                                </div>
                                                                                          </Grid>

                                                                                          <Grid item item xs={3}>
                                                                                                <div style={{ width: "100%", textAlign: "left" }}>
                                                                                                      <Fab
                                                                                                            className={classes.small}
                                                                                                            color="primary"
                                                                                                            aria-label="add"
                                                                                                            onClick={
                                                                                                                  this.saveNewPriceAgentExtraEmployee
                                                                                                            }
                                                                                                      >
                                                                                                            <AddIcon />
                                                                                                      </Fab>
                                                                                                </div>
                                                                                          </Grid>
                                                                                    </Grid>
                                                                              </Grid>
                                                                        )}
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "left" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.handleHideEnterAgent}
                                                                              >
                                                                                    {"مخفی کردن"}
                                                                              </Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Collapse>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      {showPaperChart ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHidePaperChart}>
                                                                  {"مخفی کردن"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.handleShowPaperChart}>
                                                                  {"جستجو"}
                                                            </Button>
                                                      )}

                                                      <Collapse in={showPaperChart}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="آی دی نماینده"
                                                                              value={idFilter}
                                                                              handleInputt={this.handleChangeFilterId}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="کد نماینده"
                                                                              value={codeFilter}
                                                                              handleInputt={this.handleChangeFilterCode}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Multiselect
                                                                                    style={styleselect}
                                                                                    options={optionComoany} // Options to display in the dropdown
                                                                                    //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                                                                                    onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                                                                                    onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                                                                                    ref={this.multiselectCompanyRef}
                                                                                    displayValue="label" // Property name to display in the dropdown options
                                                                                    placeholder="شرکت بیمه"
                                                                                    closeIcon="circle2"
                                                                                    emptyRecordMsg="فیلد  در دسترس نیست "
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام "
                                                                              value={nameFilter}
                                                                              handleInputt={this.handleChangeFilterName}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام خانوادگی"
                                                                              value={familyFilter}
                                                                              handleInputt={this.handleChangeFilterFamily}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Multiselect
                                                                                    style={styleselect}
                                                                                    options={optionState} // Options to display in the dropdown
                                                                                    //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                                                                                    onSelect={this.onSelectOptionState} // Function will trigger on select event
                                                                                    onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                                                                                    ref={this.multiselectStateRef}
                                                                                    displayValue="label" // Property name to display in the dropdown options
                                                                                    placeholder="استان ها "
                                                                                    closeIcon="circle2"
                                                                                    emptyRecordMsg="فیلد  در دسترس نیست "
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Multiselect
                                                                                    style={styleselect}
                                                                                    options={optionFilterCity} // Options to display in the dropdown
                                                                                    //selectedValues={selectedOptionCity} // Preselected value to persist in dropdown
                                                                                    onSelect={this.onSelectOptionCity} // Function will trigger on select event
                                                                                    onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                                                                                    ref={this.multiselectCityRef}
                                                                                    displayValue="label" // Property name to display in the dropdown options
                                                                                    placeholder="شهر ها "
                                                                                    closeIcon="circle2"
                                                                                    emptyRecordMsg="فیلد  در دسترس نیست "
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="همراه"
                                                                              value={mobileFilter}
                                                                              handleInputt={this.handleChangeFilterMobile}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">وضعیت فعالیت نماینده</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"وضعیت فعالیت نماینده"}
                                                                                    value={selectedFilterDeactive}
                                                                                    onChange={this.handleFilterDeactive}
                                                                                    options={[
                                                                                          { value: "10", label: "هر دو وضعیت" },
                                                                                          { value: "0", label: "فعال" },
                                                                                          { value: "1", label: "غیر فعال" },
                                                                                    ]}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">وضعیت آنلاین نماینده</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"وضعیت آنلاین نماینده"}
                                                                                    value={selectedFilterStatus}
                                                                                    onChange={this.handleFilterStatus}
                                                                                    options={[
                                                                                          { value: "10", label: "هر دو وضعیت" },
                                                                                          { value: "0", label: "آفلاین" },
                                                                                          { value: "1", label: "آنلاین" },
                                                                                    ]}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={this.filterFunc}>
                                                                              {"جستجو "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={this.ClearFilter}>
                                                                              {"پاک کردن فیلتر ها "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.handleHidePaperChart}
                                                                        >
                                                                              {"مخفی کردن"}
                                                                        </Button>
                                                                  </Grid>
                                                            </Grid>
                                                      </Collapse>
                                                      {showMap ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHideMap}>
                                                                  {"بستن نقشه"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.handleShowMap}>
                                                                  {"نمایش نقشه "}
                                                            </Button>
                                                      )}
                                                      <Collapse in={showMap}>{showMap ? null: null}</Collapse>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell>
                                                                                    <ExcelFile
                                                                                          element={
                                                                                                <Button variant="outlined" color="primary">
                                                                                                      {" "}
                                                                                                      {"اکسل "}
                                                                                                </Button>
                                                                                          }
                                                                                    >
                                                                                          <ExcelSheet data={agentInfofilter} name="نمایندگان">
                                                                                                <ExcelColumn label="آی دی" value="agent_id" />
                                                                                                <ExcelColumn label="جنسیت" value="agent_gender" />
                                                                                                <ExcelColumn label="نام" value="agent_name" />
                                                                                                <ExcelColumn
                                                                                                      label="نام خانوادگی"
                                                                                                      value="agent_family"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره همراه"
                                                                                                      value="agent_mobile"
                                                                                                />
                                                                                                <ExcelColumn label="تلفن دفتر" value="agent_tell" />
                                                                                                <ExcelColumn label="ایمیل" value="agent_email" />
                                                                                                <ExcelColumn
                                                                                                      label="تلفن ضروری"
                                                                                                      value="agent_required_phone"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="استان "
                                                                                                      value="agent_state_name"
                                                                                                />
                                                                                                <ExcelColumn label="شهر " value="agent_city_name" />
                                                                                                <ExcelColumn
                                                                                                      label="نام محله"
                                                                                                      value="agent_sector_name"
                                                                                                />
                                                                                                <ExcelColumn label="آدرس" value="agent_address" />
                                                                                                <ExcelColumn
                                                                                                      label="نام بانک"
                                                                                                      value="agent_bankname"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره حساب"
                                                                                                      value="agent_banknum"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره شبا"
                                                                                                      value="agent_banksheba"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شرکت بیمه"
                                                                                                      value="agent_company_name"
                                                                                                />
                                                                                                <ExcelColumn label="کد نمایندگی" value="agent_code" />
                                                                                                <ExcelColumn
                                                                                                      label="وضعیت فعالیت "
                                                                                                      value={(col) =>
                                                                                                            col.agent_deactive === "1"
                                                                                                                  ? "غیر فعال"
                                                                                                                  : "فعال"
                                                                                                      }
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="وضعیت آنلاین"
                                                                                                      value={(col) =>
                                                                                                            col.agent_status === "1"
                                                                                                                  ? "آنلاین"
                                                                                                                  : "آفلاین"
                                                                                                      }
                                                                                                />
                                                                                          </ExcelSheet>
                                                                                    </ExcelFile>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "agent_id" ? order : false}
                                                                              >
                                                                                    {" شماره نماینده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_id"}
                                                                                          direction={orderBy === "agent_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_code"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "agent_code" ? order : false}
                                                                              >
                                                                                    {" کد نمایندگی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_code"}
                                                                                          direction={orderBy === "agent_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"agent_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام و نام خانوادگی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_name"}
                                                                                          direction={orderBy === "agent_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_company_name"}
                                                                                          direction={orderBy === "agent_company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"agent_state_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" استان  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_state_name"}
                                                                                          direction={orderBy === "agent_state_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_state_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_city_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شهر  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_city_name"}
                                                                                          direction={orderBy === "agent_city_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_city_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره همراه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_mobile"}
                                                                                          direction={orderBy === "agent_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت فعالیت نماینده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_deactive"}
                                                                                          direction={orderBy === "agent_deactive" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_status"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت آنلاین "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_status"}
                                                                                          direction={orderBy === "agent_status" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_status")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["agent_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <Avatar
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["agent_image"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"agent_id"} align={"center"}>
                                                                                                      {row["agent_id"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"agent_code"} align={"center"}>
                                                                                                      {row["agent_code"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"agent_name"} align={"center"}>
                                                                                                      {row["agent_name"] + " " + row["agent_family"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"agent_company_name"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {!row["agent_company_name"] || row["agent_company_name"] === ""
                                                                                                          ? "همه شرکت‌ها"
                                                                                                          : row["agent_company_name"]}
                                                                                                </TableCell>



                                                                                                <TableCell key={"agent_state_name"} align={"center"}>
                                                                                                      {row["agent_state_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_city_name"} align={"center"}>
                                                                                                      {row["agent_city_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_mobile"} align={"center"}>
                                                                                                      {row["agent_mobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_deactive"} align={"center"}>
                                                                                                      {row["agent_deactive"] === "1" ||
                                                                                                      row["agent_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_status"} align={"center"}>
                                                                                                      {row["agent_status"] === "1" ||
                                                                                                      row["agent_status"] === 1 ? (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"آنلاین"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"آفلاین "}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeAgent)
